import React from 'react';
import { MenuItem } from 'react-bootstrap';

const ActionMenuDiver = () => (
  <MenuItem divider />
);

export default ActionMenuDiver;
